export const variabls = {
    url: ''
}